import request from "@/utils/request";

let SeckillApi = {
    /*秒杀活动列表*/
    activeList(data, errorback) {
        return request._post("/merch/activity.seckill/index", data, errorback);
    },
    getGoods(data, errorback) {
        return request._get("/merch/activity.seckill/add", data, errorback);
    },
    addGoods(data, errorback) {
        return request._post("/merch/activity.seckill/add", data, errorback);
    },
    /*我的活动列表*/
    myList(data, errorback) {
        return request._post("/merch/activity.seckill/my", data, errorback);
    },
    /*根据主键查询*/
    detailGoods(data, errorback) {
        return request._get("/merch/activity.seckill/edit", data, errorback);
    },
    /*根据主键查询*/
    saveGoods(data, errorback) {
        return request._post("/merch/activity.seckill/edit", data, errorback);
    },
    delGoods(data, errorback) {
        return request._post("/merch/activity.seckill/del", data, errorback);
    }
};
export default SeckillApi;



// WEBPACK FOOTER //
// ./src/api/seckill.js